export default {"src":"/_next/static/media/Illustration-plan.d760280c.svg","height":402,"width":456,"blurWidth":0,"blurHeight":0};